import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
interface ActivityReportDetailModalProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;
  selectedData: any;
}

const ActivityReportDetailModal: React.FC<ActivityReportDetailModalProps> = ({
  open,
  onClose,
  selectedData,
}) => {
  const details = selectedData?.activityReportDetails || [];
  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="md">
     
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)",
          color: "var(--aggrid-text-color)",
          fontSize: "16px",
          fontWeight: "bolder",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Activity Details Report
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => onClose(false)}
          style={{
            color: "var(--aggrid-text-color)",
          }}
          data-testid="close-button-activity-report-detail-modal" // For testing purposes
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ marginTop: "20px" }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>#</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Downloaded On
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  Downloaded By
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {details.length > 0 ? (
                details.map((row: any, index: number) => (
                  <TableRow key={row.id || row.downloadedOn || row.downloadedBy}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {moment
                        .utc(row.downloadedOn)
                        .local()
                        .format("MM-DD-YYYY HH:mm:ss") || "N/A"}
                    </TableCell>
                    <TableCell>{row.downloadedBy || "N/A"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No details available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(true)}
          color="primary"
          style={{
            fontSize: "15px",
            color: "var(--aggrid-text-color)",
            backgroundColor: "var(--primary-color)",
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityReportDetailModal;
